import React from 'react';
import {useField} from 'formik';
import {useIntl} from 'react-intl';
import InputText from "../../../../common/components/ui/InputText";

const FieldEmail = () => {
  const intl = useIntl();
  const labelText = intl.formatMessage({
    id: 'settings-form-email',
    defaultMessage: 'Email'
  });
  const [field, meta] = useField({name: 'email'});

  return (
    <InputText
      {...field}
      {...meta}
      variant={'full'}
      id={field.name}
      label={labelText}
      defaultValue={field.value}
      disabled={true}
    />
  );
};

export default FieldEmail;
